<div
	*ngIf="editMode"
	class="overlay bg-black opacity-30 fixed top-0 left-0 w-screen h-screen z-30"
></div>

<div>
	<div class="flex flex-row justify-between mt-4 min-h-[40px]">
		<p class="text-dark-grey font-medium text-base leading-5 m-0">
			{{ 'ORGANIZATION.STORE.DELIVERY_INFORMATION' | translate }}
		</p>
		<div
			(click)="editMode = !editMode; pushData()"
			*ngIf="!editMode"
			class="flex gap-1 ltr:mr-6 rtl:ml-6 hover:cursor-pointer"
		>
			<img class="w-5 max-h-5" src="assets/images/edit-blue.svg" alt="" />
			<p class="text-link">
				{{ 'ACTIONS.EDIT' | translate }}
			</p>
		</div>
	</div>

	<div
		class="custom-shadow rounded-12px py-12px px-24px custom-accordion {{
			editMode ? 'z-40' : ''
		}} relative bg-off-white"
	>
		<mat-accordion [dir]="translate.currentLang == 'en' ? 'ltr' : 'rtl'">
			<div class="border-b-[1px] border-b-secondry-color-Gray pb-16px">
				<mat-expansion-panel
					(closed)="shippingFeesTabExpanded = false"
					[expanded]="shippingFeesTabExpanded && editMode"
				>
					<mat-expansion-panel-header [@.disabled]="true">
						<mat-panel-title
							><div>
								<p class="text-font-16 m-0 text-dark-grey">
									{{ 'ORGANIZATION.STORE.SHIPPING_FEES' | translate }}
								</p>
								<p *ngIf="!editMode" class="text-font-16 m-0 text-medium-gray">
									SAR 30,40,60
								</p>
							</div>
						</mat-panel-title>
					</mat-expansion-panel-header>
					<div *ngIf="!editMode">
						<div
							*ngFor="let city of data; index as i"
							class="rounded-[4px] flex border-[1px] border-secondry-color-Gray justify-between p-[16px] items-center mb-8px"
						>
							<p class="text-font-16 text-medium-gray m-0">
								{{ city?.cityName }}
							</p>
							<p class="text-[#49454F] text-font-16 m-0">{{ city?.fees }}</p>
						</div>
					</div>
					<form [formGroup]="deliveryInfo" *ngIf="editMode">
						<ng-container formArrayName="cities">
							<div
								class="flex items-baseline"
								*ngFor="
									let delivery of getDeliveryInputs().controls;
									index as i
								"
							>
								<ng-container [formGroup]="delivery">
									<mat-slide-toggle
										class="ltr:mr-[8px] rtl:ml-[8px]"
										formControlName="isActive"
									></mat-slide-toggle>
									<mat-form-field
										class="{{ i == 0 ? 'w-[42%]' : 'grow' }} mr-8px mb-[30px]"
										appearance="outline"
									>
										<mat-label>{{
											'ORGANIZATION.STORE.SHIPPING_CITY' | translate
										}}</mat-label>
										<mat-select
											formControlName="cityId"
											[value]="delivery?.value?.cityName"
										>
											<mat-option
												(onSelectionChange)="selectionChange(city?.id, i)"
												*ngFor="let city of allcities"
												[value]="city.id"
												[disabled]="selectedCountries.includes(city?.id)"
												>{{
													translate.currentLang == 'en'
														? city?.name?.en
														: city?.name?.ar
												}}</mat-option
											>
										</mat-select>
										<mat-error>
											<validation-message
												[controller]="getController(i, 'city')"
												controller_name="ORGANIZATION.STORE.SHIPPING_CITY"
											>
											</validation-message>
										</mat-error>
									</mat-form-field>
									<mat-form-field
										class="{{ i == 0 ? 'w-[45%]' : 'grow' }} mr-8px mb-[30px]"
										appearance="outline"
									>
										<mat-label>{{
											'ORGANIZATION.STORE.SHIPPING_FEES' | translate
										}}</mat-label>
										<input
											class="text-medium-gray"
											formControlName="fees"
											[value]="delivery?.value?.fees"
											matInput
										/>
										<span class="text-medium-gray" matSuffix>SAR</span>
										<mat-error>
											<validation-message
												[controller]="getController(i, 'fees')"
												controller_name="ORGANIZATION.STORE.SHIPPING_FEES"
											>
											</validation-message>
										</mat-error>
									</mat-form-field>
									<button
										(click)="removeDelivery(i)"
										class="mb-12px mx-6px"
										*ngIf="i !== 0"
									>
										<img src="assets/images/delete.svg" alt="" />
									</button>
								</ng-container>
							</div>
						</ng-container>
					</form>
				</mat-expansion-panel>
				<div
					*ngIf="editMode"
					class="flex justify-end text-link p-12px cursor-pointer"
				>
					<p (click)="addInput()">
						+ {{ 'STORE.STORE_PROFILE.ADD_ANOTHER_CITY' | translate }}
					</p>
				</div>
			</div>
			<div class="mt-[16px]">
				<ng-container *ngIf="!editMode">
					<ng-container *ngFor="let company of shippingcompaniestest">
						<mat-expansion-panel>
							<mat-expansion-panel-header [@.disabled]="true">
								<mat-panel-title
									><div>
										<p
											class="text-font-12 font-Poppins-semi-bold m-0 text-dark-grey"
										>
											{{
												'ORGANIZATION.STORE.SHIPPING_COMPANY_NAME' | translate
											}}
										</p>
										<p class="text-font-16 m-0 text-medium-gray">
											{{ company?.companyName }}
										</p>
									</div>
								</mat-panel-title>
							</mat-expansion-panel-header>
							<div class="mb-12px">
								<p class="text-font-12 font-Poppins-semi-bold m-0">
									{{ 'ORGANIZATION.STORE.SHIPPING_COMPANY_NAME' | translate }}
								</p>
								<p class="text-font-16 text-medium-gray m-0">
									{{ company?.companyName }}
								</p>
							</div>
							<div class="mb-12px">
								<p class="text-font-12 font-Poppins-semi-bold m-0">
									{{
										'STORE.STORE_PROFILE.SHIPPING_CONTACT_NUMBER' | translate
									}}
								</p>
								<p class="text-font-16 text-medium-gray m-0">
									{{ company?.companyNumber }}
								</p>
							</div>
							<div>
								<p class="text-font-12 font-Poppins-semi-bold m-0">
									Contact Name
								</p>
								<p class="text-font-16 text-medium-gray m-0">
									{{ company?.contactName }}
								</p>
							</div>
						</mat-expansion-panel>
						<div
							class="h-[1px] w-full bg-secondry-color-Gray mt-16px mb-[27px]"
						></div>
					</ng-container>
				</ng-container>

				<mat-accordion *ngIf="editMode">
					<mat-expansion-panel
						(closed)="shippingCompaniesTabExpanded = false"
						[expanded]="shippingCompaniesTabExpanded"
					>
						<mat-expansion-panel-header [@.disabled]="true">
							<mat-panel-title>
								<p
									class="text-font-12 font-Poppins-semi-bold m-0 text-dark-grey"
								>
									{{ 'STORE.STORE_PROFILE.SHIPPING_COMPANIES' | translate }}
								</p>
							</mat-panel-title>
						</mat-expansion-panel-header>
						<form [formGroup]="shippingCompanies">
							<ng-container formArrayName="companies">
								<div
									*ngFor="
										let company of getDeliveryCompaniesInputs().controls;
										index as i
									"
								>
									<div class="flex items-start">
										<div
											class=" {{ i == 0 ? 'w-[92%]' : 'grow-[1]' }}"
											[formGroup]="company"
										>
											<mat-form-field
												class="mr-8px mb-[12px] w-full"
												appearance="outline"
											>
												<mat-label>{{
													'ORGANIZATION.STORE.COMPANY_NAME' | translate
												}}</mat-label>
												<div class="flex justify-between items-center">
													<input
														class="text-medium-gray"
														formControlName="companyName"
														matInput
													/>
													<img
														*ngIf="
															getCompanyController(i, 'companyName')?.value
														"
														class="inline-block cursor-pointer"
														src="./assets/images/close-square.svg"
														alt=""
														(click)="
															getCompanyController(i, 'companyName')?.setValue(
																''
															)
														"
													/>
												</div>

												<mat-error>
													<validation-message
														[controller]="
															getCompanyController(i, 'companyName')
														"
														controller_name="ORGANIZATION.STORE.SHIPPING_FEES"
													>
													</validation-message>
												</mat-error>
											</mat-form-field>
											<mat-form-field
												class="mr-8px mb-[12px] w-full"
												appearance="outline"
											>
												<mat-label>{{
													'ORGANIZATION.STORE.COMPANY_NUMBER' | translate
												}}</mat-label>

												<div class="flex justify-between items-center">
													<input
														class="text-medium-gray"
														(keypress)="isNumber($event)"
														formControlName="companyNumber"
														matInput
														[maxlength]="maxLength"
													/>
													<img
														*ngIf="
															getCompanyController(i, 'companyNumber')?.value
														"
														class="inline-block cursor-pointer"
														src="./assets/images/close-square.svg"
														alt=""
														(click)="
															getCompanyController(
																i,
																'companyNumber'
															)?.setValue('')
														"
													/>
												</div>
												<mat-error>
													<validation-message
														[controller]="
															getCompanyController(i, 'companyNumber')
														"
														controller_name="ORGANIZATION.STORE.SHIPPING_FEES"
													>
													</validation-message>
												</mat-error>
											</mat-form-field>
											<mat-form-field
												class="mr-8px mb-[12px] w-full"
												appearance="outline"
											>
												<mat-label>{{
													'ORGANIZATION.STORE.CONTACT_NAME' | translate
												}}</mat-label>

												<div class="flex justify-between items-center">
													<input
														class="text-medium-gray"
														formControlName="contactName"
														matInput
													/>
													<img
														*ngIf="
															getCompanyController(i, 'contactName')?.value
														"
														class="inline-block cursor-pointer"
														src="./assets/images/close-square.svg"
														alt=""
														(click)="
															getCompanyController(i, 'contactName')?.setValue(
																''
															)
														"
													/>
												</div>
												<mat-error>
													<validation-message
														[controller]="
															getCompanyController(i, 'contactName')
														"
														controller_name="ORGANIZATION.STORE.SHIPPING_FEES"
													>
													</validation-message>
												</mat-error>
											</mat-form-field>
										</div>
										<button
											(click)="removeShippingCompany(i)"
											class="mt-8px mx-[15px]"
											*ngIf="i !== 0"
										>
											<img src="assets/images/delete.svg" alt="" />
										</button>
									</div>
									<div
										class="h-[1px] w-full bg-secondry-color-Gray mt-16px mb-[27px]"
									></div>
								</div>
							</ng-container>
						</form>
					</mat-expansion-panel>
				</mat-accordion>
			</div>
			<div
				*ngIf="editMode"
				(click)="addCompanyInput()"
				class="flex justify-end text-link p-12px cursor-pointer"
			>
				<p>+{{ 'STORE.STORE_PROFILE.ADD_SHIPPING_COMPANY' | translate }}</p>
			</div>
		</mat-accordion>
		<div class="flex justify-end gap-3">
			<!-- cancel button  -->
			<button
				*ngIf="editMode"
				(click)="editMode = !editMode; cancel()"
				class="border border-solid border-[#D9DBE9] hover:bg-gradient hover:text-off-white mx-2"
				mat-button
			>
				{{ 'ACTIONS.CANCEL' | translate }}
			</button>
			<!-- submit button  -->
			<button
				*ngIf="editMode"
				(click)="editMode = !editMode; submit()"
				class="bg-gradient text-white"
				mat-button
			>
				{{ 'ACTIONS.SAVE' | translate }}
			</button>
		</div>
	</div>
</div>
